import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  ListProps,
} from 'react-admin'

import { FilterApp } from 'components/FilterApp'
import { Toolbar } from 'components/List'

export const ListCourses: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<CoursesFilter />}
      {...rest}
      actions={
        <Toolbar>
          <FilterApp filterCourse filterLesson={false} filterPerson={false} filterUser={false}/>
        </Toolbar>
      }
      data-testid="list"
    >
      <Datagrid rowClick="edit">
        <TextField label="#" source="id" />
        <TextField label="Ordem" source="order" />
        <TextField label="Título" source="title" />
        <TextField label="Slug" source="slug" />
        <TextField label="Descrição" source="description" />
      </Datagrid>
    </List>
  )
}
